import React from "react";
import AsesoresBanner from "../components/asesores/Banner";
import NuestrosAsesores from "../components/asesores/NuestrosAsesores";
import Goal from "../components/home/Goal";
import GarlasBanner from "../components/banner/Banner";
import Infort from "../components/home/Infort";

const Asesores = () => (
  <>
    <AsesoresBanner />
    <NuestrosAsesores />
    <Goal />
    <Infort />
    <GarlasBanner />
  </>
);

export default Asesores;
